import { FeaturePathMenus } from "core/FeaturePathMenus";

// url_id is url that contains in user pemissions
// url_path is url that reference to url_id
const pathMenus = [
  {
    url_id: "/dashboard",
    url_path: "/dashboard",
  },
  {
    url_id: "/messaging",
    url_path: "/messaging",
  },
  {
    url_id: "/list/kelola-pengguna",
    url_path: "/list/kelola-pengguna",
  },
  {
    url_id: "/list/kelola-pengguna",
    url_path: "/form/kelola-pengguna",
  },
  {
    url_id: "/list/kelola-nasabah",
    url_path: "/list/kelola-nasabah",
  },
  {
    url_id: "/list/kelola-hak-akses",
    url_path: "/list/kelola-hak-akses",
  },
  {
    url_id: "/list/kelola-hak-akses",
    url_path: "/form/kelola-hak-akses",
  },
  {
    url_id: "/list/persetujuan",
    url_path: "/list/persetujuan",
  },
  {
    url_id: "/list/persetujuan",
    url_path: "/form/persetujuan",
  },
  {
    url_id: "/list/persetujuan",
    url_path: "/list/persetujuan/history",
  },
  {
    url_id: "/list/persetujuan",
    url_path: "/form/persetujuan/history",
  },
  {
    url_id: "/list/persetujuan",
    url_path: "/list/persetujuan/blokir-rekening",
  },
  {
    url_id: "/list/persetujuan",
    url_path: "/list/persetujuan/blokir-id",
  },
  {
    url_id: "/list/refund-rtjh",
    url_path: "/list/refund-rtjh",
  },
  {
    url_id: "/parameter/global",
    url_path: "/parameter/global",
  },
  {
    url_id: "/parameter/global",
    url_path: "/form/parameter/global",
  },
  {
    url_id: "/parameter/template",
    url_path: "/parameter/template",
  },
  {
    url_id: "/parameter/template",
    url_path: "/form/parameter/template",
  },
  {
    url_id: "/parameter/instance",
    url_path: "/parameter/instance",
  },
  {
    url_id: "/parameter/instance",
    url_path: "/form/parameter/instance",
  },
  {
    url_id: "/setup-bonus/product-wadiah",
    url_path: "/setup-bonus/product-wadiah",
  },
  {
    url_id: "/laporan/kesepakatan-nasabah",
    url_path: "/laporan/kesepakatan-nasabah",
  },
  {
    url_id: "/laporan/audit-trail",
    url_path: "/laporan/audit-trail",
  },
  {
    url_id: "/laporan/transaksi",
    url_path: "/laporan/transaksi",
  },
  {
    url_id: "/laporan/blokir-rekening",
    url_path: "/laporan/blokir-rekening",
  },
  {
    url_id: "/laporan/blokir-saldo",
    url_path: "/laporan/blokir-saldo",
  },
  {
    url_id: "/gold-financing/close-gold-fin-account",
    url_path: "/gold-financing/close-gold-fin-account",
  },
  {
    url_id: "/list/audit-trail-user-activity",
    url_path: "/list/audit-trail-user-activity",
  },
  {
    url_id: "/revised-transaction-status/input",
    url_path: "/revised-transaction-status/input",
  },
  {
    url_id: "/revised-transaction-status/input",
    url_path: "/revised-transaction-status/form/",
  },
  {
    url_id: "/list/report-customer-rtjh",
    url_path: "/list/report-customer-rtjh",
  },
  {
    url_id: "/gold-financing/download",
    url_path: "/gold-financing/download",
  },
  {
    url_id: "/parameter-transaksi/institusi-pembayaran",
    url_path: "/parameter-transaksi/institusi-pembayaran",
  },
  {
    url_id: "/parameter-transaksi/institusi-pembayaran",
    url_path: "/audit/parameter-transaksi/institusi-pembayaran",
  },
  {
    url_id: "/parameter-transaksi/hari-libur",
    url_path: "/parameter-transaksi/hari-libur",
  },
  {
    url_id: "/parameter-transaksi/hari-libur",
    url_path: "/audit/parameter-transaksi/hari-libur",
  },
  {
    url_id: "/parameter-transaksi/tipe-transaksi",
    url_path: "/parameter-transaksi/tipe-transaksi",
  },
  {
    url_id: "/parameter-transaksi/bank-tujuan",
    url_path: "/parameter-transaksi/bank-tujuan",
  },
  {
    url_id: "/parameter-transaksi/bank-tujuan",
    url_path: "/audit/parameter-transaksi/bank-tujuan",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-id",
    url_path: "/list/kelola-nasabah/blokir-id",
  },
  {
    url_id: "/laporan/blokir-id",
    url_path: "/laporan/blokir-id",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-saldo",
    url_path: "/list/kelola-nasabah/blokir-saldo",
  },
  {
    url_id: "/list/kelola-nasabah/form",
    url_path: "/list/kelola-nasabah",
  },
  {
    url_id: "/blokir/tutup-fasilitas",
    url_path: "/blokir/tutup-fasilitas",
  },
  {
    url_id: "/kelola-nasabah/blokir-saldo",
    url_path: "/kelola-nasabah/blokir-saldo",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-saldo",
    url_path: "/list/kelola-nasabah/blokir-saldo",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-saldo",
    url_path: "/form/kelola-nasabah/blokir-saldo",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-rekening",
    url_path: "/list/kelola-nasabah/blokir-rekening",
  },
  {
    url_id: "/list/kelola-nasabah/blokir-rekening",
    url_path: "/form/kelola-nasabah/blokir-rekening",
  },
  {
    url_id: "/list/kelola-nasabah/kelola-device",
    url_path: "/list/kelola-nasabah/kelola-device",
  },
  {
    url_id: "/list/persetujuan/kelola-device",
    url_path: "/list/persetujuan/kelola-device",
  },
  {
    url_id: "/list/persetujuan/kelola-device",
    url_path: "/form/persetujuan/kelola-device",
  },
  {
    url_id: "/laporan/kelola-device",
    url_path: "/laporan/kelola-device",
  },
  {
    url_id: "/laporan/kelola-device",
    url_path: "/form/laporan/kelola-device",
  },
  {
    url_id: "/kelola-inbox/info",
    url_path: "/kelola-inbox/info",
  },
  {
    url_id: "/kelola-inbox/info",
    url_path: "/form/kelola-inbox/info",
  },
  {
    url_id: "/list/persetujuan/kelola-info",
    url_path: "/list/persetujuan/kelola-info",
  },
  {
    url_id: "/list/persetujuan/kelola-info",
    url_path: "/form/persetujuan/kelola-info",
  },
  {
    url_id: "/laporan/kelola-info",
    url_path: "/laporan/kelola-info",
  },
  {
    url_id: "/laporan/kelola-info",
    url_path: "/form/laporan/kelola-info",
  },
  {
    url_id: "/kelola-inbox/promo",
    url_path: "/kelola-inbox/promo",
  },
  {
    url_id: "/kelola-inbox/promo",
    url_path: "/form/kelola-inbox/promoo",
  },
  {
    url_id: "/list/persetujuan/kelola-promo",
    url_path: "/list/persetujuan/kelola-promo",
  },
  {
    url_id: "/list/persetujuan/kelola-promo",
    url_path: "/form/persetujuan/kelola-promo",
  },
  {
    url_id: "/laporan/kelola-promo",
    url_path: "/laporan/kelola-promo",
  },
  {
    url_id: "/laporan/kelola-promo",
    url_path: "/form/laporan/kelola-promo",
  },
  {
    url_id: "/laporan/multidevice",
    url_path: "/laporan/multidevice",
  },
  {
    url_id: "/parameter-transaksi/zakat-donasi",
    url_path: "/parameter-transaksi/zakat-donasi",
  },
  {
    url_id: "/list/persetujuan/bank-tujuan",
    url_path: "/list/persetujuan/bank-tujuan",
  },
  {
    url_id: "/list/persetujuan/bank-tujuan",
    url_path: "/form/persetujuan/bank-tujuan",
  },
  {
    url_id: "/laporan/parameter-bank-tujuan",
    url_path: "/laporan/parameter-bank-tujuan",
  },
  {
    url_id: "/laporan/parameter-bank-tujuan",
    url_path: "/form/laporan/parameter-bank-tujuan",
  },
  {
    url_id: "/laporan/aktivasi-saku-valas",
    url_path: "/laporan/aktivasi-saku-valas",
  },
  {
    url_id: "/laporan/outstanding-valas",
    url_path: "/laporan/outstanding-valas",
  },
  {
    url_id: "/laporan/mutasi-valas",
    url_path: "/laporan/mutasi-valas",
  },

  {
    url_id: "/list/kelola-login-screen",
    url_path: "/list/kelola-login-screen",
  },
  {
    url_id: "/list/kelola-login-screen",
    url_path: "/form/kelola-login-screen",
  },

  // NOTE: V2 Path Menus, do not touch
  ...FeaturePathMenus,
];

export default pathMenus;
